/**
 * The initial auth state.
 */
export const initialAuthState = {
  isInitialized: false,
  user: undefined,
}
